import { STUDENT_PROXY_LOGIN, STUDENT_PROXY_LOGOUT} from "../actions-index.js";

export function studentProxyLogin(state = {}, action = {}) {
    return (action.type === STUDENT_PROXY_LOGIN ? action.payload : state);
}

export function studentProxyLogout(state = {}, action = {}) {
    return (action.type === STUDENT_PROXY_LOGOUT ? action.payload : state);
}